import ChessButton from "../../visual/ChessButton/ChessButton";
import "./PuzzleDetailsModal.scss";

interface PuzzleDetailsModalProps {
    formattedDate: string;
    isToday: boolean;
    puzzleData: {
        puzzle: {
            title: string;
            fen: string;
            pgn: string;
            moves: string[];
            playerColor: string;
        };
        completed: boolean;
        attempts: number;
        hintsUsed: number;
        completedAt?: string;
    } | null;
    isLoading: boolean;
    onPlay: () => void;
    onClose: () => void;
}

/**
 * PuzzleDetailsModal component
 * Modal dialog showing details of a selected puzzle from the calendar
 * Displays completion status, attempts, hints used, and a play/continue button
 */
export default function PuzzleDetailsModal({
    formattedDate,
    isToday,
    puzzleData,
    isLoading,
    onPlay,
    onClose,
}: PuzzleDetailsModalProps) {
    return (
        <div className="puzzle-details-overlay" onClick={onClose}>
            <div className="puzzle-details-modal" onClick={(e) => e.stopPropagation()}>
                <button className="puzzle-details-modal__close" onClick={onClose}>
                    ✕
                </button>

                {isLoading ? (
                    <div className="puzzle-details-modal__content">
                        <p>Loading puzzle...</p>
                    </div>
                ) : puzzleData ? (
                    <div className="puzzle-details-modal__content">
                        <h2>{isToday ? "Today's Puzzle" : `Puzzle from ${formattedDate}`}</h2>
                        <div className="puzzle-stats">
                            <p>
                                <strong>Status:</strong>{" "}
                                {puzzleData.completed
                                    ? "✓ Completed"
                                    : puzzleData.attempts > 0
                                      ? "Attempted"
                                      : "Not Started"}
                            </p>
                            {puzzleData.attempts > 0 && (
                                <>
                                    <p>
                                        <strong>Attempts:</strong> {puzzleData.attempts}
                                    </p>
                                    <p>
                                        <strong>Hints Used:</strong> {puzzleData.hintsUsed}
                                    </p>
                                </>
                            )}
                            {puzzleData.completedAt && (
                                <p>
                                    <strong>Completed:</strong>{" "}
                                    {new Date(puzzleData.completedAt).toLocaleString()}
                                </p>
                            )}
                        </div>
                        <ChessButton onClick={onPlay}>
                            {puzzleData.completed
                                ? "Replay Puzzle"
                                : puzzleData.attempts > 0
                                  ? "Continue Puzzle"
                                  : "Play Puzzle"}
                        </ChessButton>
                    </div>
                ) : (
                    <div className="puzzle-details-modal__content">
                        <h2>{isToday ? "Today's Puzzle" : `Puzzle from ${formattedDate}`}</h2>
                        <p>Click &quot;Play Puzzle&quot; to start!</p>
                        <ChessButton onClick={onPlay}>Play Puzzle</ChessButton>
                    </div>
                )}
            </div>
        </div>
    );
}
